var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _JasBoardsClient_instances, _JasBoardsClient_encryption, _JasBoardsClient_httpClient, _JasBoardsClient_awsConfig, _JasBoardsClient_jasBoardURL, _JasBoardsClient_getSignedHeaders;
import { normalizeBoard } from '../utils/normalizeBoard';
import { awsConfigSchema, getBoardParamsSchema, responseBoardSchema } from './validation';
export class JasBoardsClient {
    constructor({ encryption, httpClient, awsConfig, jasBaseURL, }) {
        _JasBoardsClient_instances.add(this);
        _JasBoardsClient_encryption.set(this, void 0);
        _JasBoardsClient_httpClient.set(this, void 0);
        _JasBoardsClient_awsConfig.set(this, void 0);
        _JasBoardsClient_jasBoardURL.set(this, void 0);
        __classPrivateFieldSet(this, _JasBoardsClient_awsConfig, awsConfigSchema.parse(awsConfig), "f");
        __classPrivateFieldSet(this, _JasBoardsClient_encryption, encryption, "f");
        __classPrivateFieldSet(this, _JasBoardsClient_httpClient, httpClient, "f");
        __classPrivateFieldSet(this, _JasBoardsClient_jasBoardURL, `${jasBaseURL}/verify/boards`, "f");
    }
    getBoard(params) {
        const { boardName } = getBoardParamsSchema.parse(params);
        const uri = `${__classPrivateFieldGet(this, _JasBoardsClient_jasBoardURL, "f")}/${boardName}`;
        const { code, body, errorBody } = __classPrivateFieldGet(this, _JasBoardsClient_httpClient, "f").get(uri, __classPrivateFieldGet(this, _JasBoardsClient_instances, "m", _JasBoardsClient_getSignedHeaders).call(this, { httpMethod: 'GET', uri }));
        if (code !== 200) {
            const board = responseBoardSchema.parse(JSON.parse(errorBody));
            return normalizeBoard(board);
        }
        if (!body) {
            throw Error('No body');
        }
        const board = responseBoardSchema.parse(body);
        return normalizeBoard(board);
    }
}
_JasBoardsClient_encryption = new WeakMap(), _JasBoardsClient_httpClient = new WeakMap(), _JasBoardsClient_awsConfig = new WeakMap(), _JasBoardsClient_jasBoardURL = new WeakMap(), _JasBoardsClient_instances = new WeakSet(), _JasBoardsClient_getSignedHeaders = function _JasBoardsClient_getSignedHeaders({ httpMethod, uri }) {
    const config = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _JasBoardsClient_awsConfig, "f")), { uri,
        httpMethod });
    return __classPrivateFieldGet(this, _JasBoardsClient_encryption, "f").awsSignV4(config);
};
